import {Controller} from "stimulus"

// Manages add/remove of contact method rows within a medium section
// (Phone, E-mail, Mail, URL). Clones a template row for addRow,
// and marks persisted rows with _destroy or removes new rows from DOM.
export default class extends Controller {
    static targets = ["rows", "row"]

    get medium() {
        return this.element.dataset.medium
    }

    connect() {
        if (this.rowTargets.length > 0) {
            this._templateRow = this.rowTargets[0].cloneNode(true)
            this._cleanTemplate(this._templateRow)
        }
    }

    addRow() {
        if (!this._templateRow) return

        var newRow = this._templateRow.cloneNode(true)
        var newIndex = Date.now()
        this._updateIndices(newRow, newIndex)
        this.rowsTarget.appendChild(newRow)
    }

    removeRow(e) {
        var row = e.target.closest("[data-target~='contact-method-section.row']")
        if (!row) return

        var methodIdField = this._findMethodIdField(row)

        if (methodIdField) {
            var destroyField = row.querySelector(".destroy-flag")
            if (destroyField) destroyField.value = "1"
            row.style.display = "none"
        } else {
            row.remove()
        }
    }

    _findMethodIdField(row) {
        var inputs = row.querySelectorAll("input[type='hidden']")
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].name.match(/contact_methods_attributes\]\[\d+\]\[id\]$/)) {
                return inputs[i]
            }
        }
        return null
    }

    _cleanTemplate(row) {
        var idField = this._findMethodIdField(row)
        if (idField) idField.remove()

        row.querySelectorAll("input[type='text'], input[type='tel'], input[type='email'], input[type='url']").forEach(function (el) {
            el.value = ""
        })

        // Reset selects (e.g. Role) to first option so new rows default correctly
        row.querySelectorAll("select").forEach(function (sel) {
            sel.selectedIndex = 0
        })

        var destroyField = row.querySelector(".destroy-flag")
        if (destroyField) destroyField.value = ""

        // Remove hat limits and preferences from template (only shown for persisted records)
        row.querySelectorAll(".method-options").forEach(function (el) {
            el.remove()
        })

        // Remove hat designations from template (only shown for persisted records)
        var hatSection = row.querySelector(".hat-designations")
        if (hatSection) hatSection.remove()

        if (this.medium === "Mail") {
            var displayArea = row.querySelector("[data-target~='address-form.display']")
            if (displayArea) {
                displayArea.innerHTML = ""
                displayArea.classList.add("hidden")
            }

            var formArea = row.querySelector("[data-target~='address-form.form']")
            if (formArea) formArea.classList.remove("hidden")

            var addressIdField = row.querySelector("input.address-id")
            if (addressIdField) addressIdField.value = ""

            row.querySelectorAll("input[name*='[address_attributes]']").forEach(function (el) {
                el.value = ""
            })
        }
    }

    _updateIndices(row, newIndex) {
        row.querySelectorAll("[name]").forEach(function (el) {
            el.name = el.name.replace(
                /contact_methods_attributes\]\[\d+\]/,
                "contact_methods_attributes][" + newIndex + "]"
            )
        })

        row.querySelectorAll("[id]").forEach(function (el) {
            el.id = el.id.replace(
                /contact_methods_attributes_\d+_/,
                "contact_methods_attributes_" + newIndex + "_"
            )
        })

        row.querySelectorAll("label[for]").forEach(function (el) {
            var forAttr = el.getAttribute("for")
            el.setAttribute("for", forAttr.replace(
                /contact_methods_attributes_\d+_/,
                "contact_methods_attributes_" + newIndex + "_"
            ))
        })
    }
}
